import * as React from 'react';
import { navigate } from '@reach/router';
import { Alert, Input, Form, Row, Col } from '@nackle/paper';
import { Section, SectionHeader } from '@nackle/studio-tools';
// components
import PDFUpload from 'shared/pdf-upload';
import VersionsNav from 'shared/versions-nav';
import FileItem from './file-item';
import SaveButton from 'shared/save-button';


//styles
import './privacy.less';

export default class PrivacyWrapper extends React.Component {
    state = {
        errors: {
            noLocaleError: false,
            sameLocaleError: false,
            fileNameError: false
        }
    };
    constructor( props ) {
        super( props );

        this.props.getLocales();
        this.props.getPrivacy( this.props.privacyId );
    }
    handlePDFFile = async PDFFiles => {
        await PDFFiles.map( async file => {
            const reader = new FileReader();
            await reader.addEventListener(
                'loadend',
                () => this.props.addFile( reader.result, file.name ),
                false
            );
            reader.readAsArrayBuffer( file );
        } );
    };
    handleValue = event => {
        const { name, value } = event.target;
        this.props.setPrivacyValue( name, value );
    };
    componentWillUnmount() {
        this.props.clearPrivacy();
    }
    savePrivacyFiles = async () => {
        const { privacyId, files, description } = this.props;
        const errors = this.props.checkForErrors();
        if ( !errors.noLocaleError && !errors.sameLocaleError ) {
            this.setState( { errors: false } );
            return await this.props
                .savePrivacyFiles( privacyId, { files, description } )
                .then( () => navigate( `/${ this.props.companyId }` ) );
        } else {
            return await this.setState( { errors } );
        }
    };
    render() {
        const {
            path,
            companyId,
            files,
            description,
            status,
            readPrivacyVersions,
            enableUploadPrivacyFiles,
            editVersions
        } = this.props;
        const errors = this.state.errors;

        if ( !readPrivacyVersions ) {
            return (
                <div>
                    <VersionsNav path={ path } companyId={ companyId } />
                    <Alert type="warning" message="Access Denied." showIcon />
                </div>
            );
        }

        return (
            <React.Fragment>
                <VersionsNav path={ path } companyId={ companyId } />
                <Section>
                    <SectionHeader title="" />
                    <Row>
                        <Col span={ 24 }>
                            { status === 'Saved' && (
                                <div className="form-container">
                                    <Form>
                                        <Form.Item>
                                            <span className="form-group-label">Upload PDFs</span>
                                        </Form.Item>
                                        <Form.Item>
                                            <PDFUpload
                                                handlePDFFile={ this.handlePDFFile }
                                                disabled={ !enableUploadPrivacyFiles }
                                            />
                                        </Form.Item>
                                    </Form>
                                    <div>
                                        <Form>
                                            <Form.Item>
                                                <span className="form-group-label">Uploaded PDFs</span>
                                            </Form.Item>
                                            <Form.Item>
                                                { !!files.length && (
                                                    <div className="list">
                                                        <div className="list-header">
                                                            <Row className="list-row">
                                                                <Col span={ 2 } className="list-item dark" />
                                                                <Col span={ 10 } className="list-item dark">
                                                            <span className="list-header-text">
                                                                File Name
                                                            </span>
                                                                </Col>
                                                                <Col span={ 4 } className="list-item dark">
                                                            <span className="list-header-text">
                                                                Locale
                                                            </span>
                                                                </Col>
                                                                <Col span={ 4 } className="list-item dark">
                                                            <span className="list-header-text">
                                                                Download
                                                            </span>
                                                                </Col>
                                                                <Col span={ 4 } className="list-item dark">
                                                            <span className="list-header-text">
                                                                Remove
                                                            </span>
                                                                </Col>
                                                            </Row>
                                                        </div>
                                                        <div className="list-rows">
                                                            { files.map( file => (
                                                                <FileItem
                                                                    key={ file.key }
                                                                    file={ file }
                                                                    status={ status }
                                                                    errors={ errors }
                                                                    files={ files }
                                                                />
                                                            ) ) }
                                                        </div>
                                                    </div>
                                                ) }
                                            </Form.Item>
                                            <Form.Item>
                                                { !files.length && (
                                                    <span className="subtle-text">No uploaded files.</span>
                                                ) }
                                            </Form.Item>
                                        </Form>
                                    </div>
                                    { errors.noLocaleError && (
                                        <Row>
                                            <Col span={ 20 }>
                                                <Alert
                                                    type="error"
                                                    message="Every PDF file must have a locale assigned."
                                                    showIcon
                                                />
                                            </Col>
                                        </Row>
                                    ) }
                                    { errors.sameLocaleError && (
                                        <Row>
                                            <Col span={ 20 }>
                                                <Alert
                                                    type="error"
                                                    message="Can not have two pdf files with the same locale."
                                                    showIcon
                                                />
                                            </Col>
                                        </Row>
                                    ) }
                                    { errors.fileNameError && (
                                        <Row>
                                            <Col span={ 20 }>
                                                <Alert
                                                    type="error"
                                                    message='File names must be alphanumeric and can only include"-" and "_" characters.'
                                                    showIcon
                                                />
                                            </Col>
                                        </Row>
                                    ) }
                                    <>
                                        <Form>
                                            <Form.Item>
                                                <span className="form-group-label">Description</span>
                                            </Form.Item>
                                            <Form.Item>
                                                    <span className="subtle-text">
                                                        What changed in this version?
                                                    </span>
                                            </Form.Item>
                                            <Form.Item>
                                                <Input.TextArea
                                                    name="description"
                                                    onChange={ this.handleValue }
                                                    value={ description ? description : '' }
                                                />
                                            </Form.Item>
                                            <Form.Item>
                                                <SaveButton
                                                    id="saveAutomaticProcessesButton"
                                                    save={ this.savePrivacyFiles }
                                                    disabled={ !files.length || !editVersions }
                                                    text="Save and Return"
                                                    className="save-button"
                                                />
                                            </Form.Item>
                                        </Form>
                                    </>
                                </div>
                            ) }
                            { status !== 'Saved' && (
                                <>
                                    <Form>
                                        <Form.Item>
                                            <span className="form-group-label">Uploaded PDFs</span>
                                        </Form.Item>
                                        <Form.Item>
                                            { !!files.length && (
                                                <div className="list">
                                                    <div className="list-header">
                                                        <Row className="list-row">
                                                            <Col span={ 2 } className="list-item dark" />
                                                            <Col span={ 10 } className="list-item dark">
                                                        <span className="list-header-text">
                                                            File Name
                                                        </span>
                                                            </Col>
                                                            <Col span={ 6 } className="list-item dark">
                                                        <span className="list-header-text">
                                                            Locale
                                                        </span>
                                                            </Col>
                                                            <Col span={ 6 } className="list-item dark">
                                                        <span className="list-header-text">
                                                            Download
                                                        </span>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                    <div className="list-rows">
                                                        { files.map( file => (
                                                            <FileItem
                                                                key={ file.key }
                                                                file={ file }
                                                                status={ status }
                                                                errors={ {} }
                                                            />
                                                        ) ) }
                                                    </div>
                                                </div>
                                            ) }
                                        </Form.Item>
                                        <Form.Item>
                                            { !files.length && (
                                                <span className="subtle-text">No uploaded files.</span>
                                            ) }
                                        </Form.Item>
                                    </Form>
                                    <Form>
                                        <Form.Item>
                                            <span className="form-group-label">Description</span>
                                        </Form.Item>
                                        <Form.Item>
                                            <p>{ description ? description : 'No description provided.' }</p>
                                        </Form.Item>
                                    </Form>
                                </>
                            ) }
                        </Col>
                    </Row>
                </Section>
            </React.Fragment>
        );
    }
}
